import React from 'react';
import Icon from 'icons/Icon';
import { AccordionOpenCloseIcon } from 'components/custom/AccordionIndicators';
import SarFieldInfoButton from '../SarFieldInfoModalComponent';
import SarFieldInfoBubbleButton from './SarFieldInfoBubble';

const SarInfoRow = ({
  label,
  children,
  hasSeparator = false,
  contentClassName = 'flex items-center justify-end min-w-[240px] max-w-[320px] w-full',
  infoLabel = 'Information',
  infoConfig,
  hasError = false,
}: SarInfoRowProps) => (
  <div
    className={`flex justify-between items-center pl-10 pr-5 2xl:pr-6 min-h-[52px] 2xl:min-h-[54px] h-fit py-2 bg-white w-full ${hasSeparator ? 'border-t border-[#F2F4F7]' : ''}`}
  >
    <div className={'flex items-center gap-x-2'}>
      <AccordionOpenCloseIcon hasError={hasError} expanded={false} />
      <div className={'flex flex-col'}>
        <div className={'flex items-center gap-x-2'}>
          <span className={`text-xs tracking-wide text-f-black-2 ${hasError ? 'text-f-red-1' : ''}`}>{infoLabel}</span>
          {(() => {
            const iconElement = (
              <Icon
                icon={'kyc_informationicon'}
                className={`text-f-black-2 hover:opacity-50 opacity-100 transition-opacity duration-200 ${hasError ? 'text-f-red-1' : ''}`}
              />
            );

            if (!infoConfig) {
              return (
                <button className='w-3 flex items-center justify-center rounded-full' aria-label='Bilgi' onClick={(event) => event.stopPropagation()}>
                  {iconElement}
                </button>
              );
            }

            switch (infoConfig.mode) {
              case 'modal':
                return (
                  <SarFieldInfoButton
                    fieldPath={infoConfig.path}
                    fieldLabel={label}
                    fieldType={infoConfig.type ?? 'Metin'}
                    additionalInfo={infoConfig.additionalInfo}
                    trigger={iconElement}
                  />
                );
              case 'bubble':
              default:
                return (
                  <SarFieldInfoBubbleButton
                    fieldPath={infoConfig.path}
                    fieldLabel={label}
                    fieldType={infoConfig.type ?? 'Metin'}
                    additionalInfo={infoConfig.additionalInfo}
                    trigger={iconElement}
                  />
                );
            }
          })()}
        </div>
        <span className={`text-sm font-medium text-[#1D2939] ${hasError ? 'text-f-red-1' : ''}`}>{label}</span>
      </div>
    </div>
    <div className={contentClassName}>{children}</div>
  </div>
);

interface SarInfoRowProps {
  label: string;
  children: React.ReactNode;
  hasSeparator?: boolean;
  contentClassName?: string;
  infoLabel?: string;
  infoConfig?: {
    path: string;
    type?: string;
    additionalInfo?: string;
    mode?: 'bubble' | 'modal';
  };
  hasError?: boolean;
}

export default SarInfoRow;
